import { render, staticRenderFns } from "./resetpwd.vue?vue&type=template&id=24952054&"
import script from "./resetpwd.vue?vue&type=script&lang=js&"
export * from "./resetpwd.vue?vue&type=script&lang=js&"
import style0 from "./resetpwd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports